import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="ub-header">
      <div className="container">
        <div className="logo">
          <Link to="/">UB Resources</Link>
        </div>

        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          <div className="desktop-nav-wrapper">
            <ul>
              <li>
                <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink to="/products" className={({ isActive }) => isActive ? 'active' : ''}>
                  Products
                </NavLink>
              </li>
              <li>
                <NavLink to="/about" className={({ isActive }) => isActive ? 'active' : ''}>
                  About
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact" className={({ isActive }) => isActive ? 'active' : ''}>
                  Contact
                </NavLink>
              </li>
              <li>
                <NavLink to="/quotes" className={({ isActive }) => isActive ? 'active' : ''}>
                  Quotes
                </NavLink>
              </li>
            </ul>
            <a href="/catalogue.pdf" download className="download-btn desktop-download">
  Download Catalogue
</a>

          </div>
        </nav>

        {/* Hamburger for mobile */}
        <button 
          className={`hamburger ${isMenuOpen ? 'active' : ''}`} 
          onClick={toggleMenu}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Mobile Menu Modal */}
        {isMenuOpen && (
          <div className="mobile-menu-modal">
            <div className="mobile-menu-content">
              <nav className="mobile-nav">
                <ul>
                  <li><NavLink to="/" onClick={toggleMenu}>Home</NavLink></li>
                  <li><NavLink to="/products" onClick={toggleMenu}>Products</NavLink></li>
                  <li><NavLink to="/about" onClick={toggleMenu}>About</NavLink></li>
                  <li><NavLink to="/contact" onClick={toggleMenu}>Contact</NavLink></li>
                  <li><NavLink to="/quotes" onClick={toggleMenu}>Quotes</NavLink></li>
                </ul>
              </nav>

              <a href="/catalogue.pdf" download className="download-btn desktop-download">
  Download Catalogue
</a>


              <button 
                className="close-menu" 
                onClick={toggleMenu}
                aria-label="Close menu"
              >
                &times;
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
